// App.vue

<template src="./templates/main.html"></template>

<script src="./js/main.js"></script>

<style lang="scss" scoped src="./css/main.scss"></style>
